import { useMemo } from "react"

import { Typography } from "@l2r-front/l2r-ui"
import { formatMetersToDistance, useUrlParams } from "@l2r-front/l2r-utils"

import { LINEAR_LOCATION_END, LINEAR_LOCATION_START } from "../../constants/urlParams"

export const SectionLength = () => {

    const { getParam } = useUrlParams()

    const roadLength = useMemo(() => {
        const lengthInMeters = Math.abs(getParam(LINEAR_LOCATION_END) - getParam(LINEAR_LOCATION_START))

        return formatMetersToDistance(lengthInMeters)
    }, [getParam])

    if (!roadLength) {
        return null
    }

    return (
        <Typography id="road-detail-length" variant="Desktop & Mobile/Body/Regular">{roadLength}</Typography>
    )
}